import { useMemo } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { ActionDropdown, ListTable } from '@nv/components'
import { formatDateLocaleShort } from '@nv/utils'
import clsx from 'clsx'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './DuplicationsTable.module.scss'

export const DuplicationsTable = ({ duplicates }) => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const currentLanguage = i18n.language
  const electorActionOptions = []
  if (
    KeycloakAdminService.isSuperAdmin() ||
    KeycloakAdminService.isContactInfoRoleAdmin() ||
    KeycloakAdminService.isVBMAdmin() ||
    KeycloakAdminService.isMonitoringAdmin()
  ) {
    electorActionOptions.push({ value: 'View', label: t('main.view') })
  }

  const duplicateApproved = duplicates.some((d) => d.voterInfo.status === 'Approved')

  const columns = useMemo(() => {
    const cols = [
      {
        accessorKey: 'username',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.username'),
      },
      {
        accessorKey: 'voterInfo.fullName',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.fullName'),
      },
      // {
      //   accessorKey: 'voterInfo.knownIdNumber',
      //   cell: (info) => info.getValue() || '',
      //   header: () => t('admin.electorsList.knownIdNumber'),
      // },
      {
        accessorKey: 'voterInfo.address.fullAddress',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.address'),
      },
      {
        accessorKey: 'voterInfo.dateOfBirth',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.dateOfBirth'),
      },
      {
        accessorKey: 'email',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.email'),
      },
      {
        accessorKey: 'createdAt',
        cell: (info) => formatDateLocaleShort(info.getValue(), currentLanguage) || '',
        header: () => t('admin.onlineRegistration.registrationDate'),
      },
      {
        accessorKey: 'voterInfo.status',
        cell: (info) => (
          <span className={clsx(styles[`status-label`], styles[`status-label__${info.getValue().toLowerCase()}`])}>
            {t(`registration.registrationStatus.${info.getValue().toLowerCase()}`)}
          </span>
        ),
        header: () => t('admin.electorsList.applicationStatus'),
      },
    ]
    if (electorActionOptions.length) {
      cols.push({
        accessorKey: 'action',
        cell: (info) => (
          <ActionDropdown
            values={electorActionOptions}
            onCallback={(choice) => {
              const voterId = info.row.original?.voterInfo?._id
              switch (choice) {
                case 'View':
                  if (voterId) {
                    navigate(`/admin/registrant-details/${voterId}`)
                  } else {
                    alert('User is not viewable.')
                  }
                  break
                default:
                  break
              }
            }}
          />
        ),
        header: () => t('buttons.action'),
      })
    }
    return cols
  }, [currentLanguage])

  return (
    <div className={styles['table-container']}>
      <h2 className={styles['header']}>
        {t('admin.electorsDetails.profileDuplication')}
        {duplicateApproved && <span className={styles['duplicate-label']}>{t('admin.electorsDetails.duplicateApproved')}</span>}
      </h2>

      <ListTable data={duplicates} columns={columns} loading={false} />
    </div>
  )
}
